import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import generateNaturalLanguageSearchUrl from '../utils/naturalLanguageUtils';

const useNaturalLanguageSearch = (handleAiSearchOverride?: (param: string) => void) => {
  const languageRegionCode = useLanguageRegionCode();

  const handleAiSearch = handleAiSearchOverride
    ? handleAiSearchOverride
    : (nlq: string) => {
        const route = generateNaturalLanguageSearchUrl(nlq, languageRegionCode);
        window.location.href = route;
      };

  return { handleAiSearch };
};

export default useNaturalLanguageSearch;
